export enum AgrometeorologyRoutes {
    WeatherToday = "/agrometeorologija/danas",
    CityWeatherForecast = "/agrometeorologija/prognoza",
    AgrometeorologyForecast = "/agrometeorologija/agrometeoroloska-prognoza",
    CloudMovement = "/agrometeorologija/karta-kretanja-oblaka",
    WindAndTemperatureMap = "/agrometeorologija/karta-vjetra-i-temperature",
}

export enum NewsRoutes {
    News = "/vijesti-i-savjeti/vijesti",
    Advice = "/vijesti-i-savjeti/savjeti",
    Advisers = "/vijesti-i-savjeti/savjetnici",
}

export enum PlantProtectionRoutes {
    PestAnalysis = "/zastita-bilja/analiza-stanja-stetnika",
    PestPopulationSize = "/zastita-bilja/brojnost-populacije-stetnika",
    Phenophases = "/zastita-bilja/faze-rasta-i-razvoja-biljaka",
    FlavescenceDoreeMap = "/zastita-bilja/karta-zlatne-zutice",
    DiseasesAndPests = "/zastita-bilja/bolesti-stetnici",
    Recommendations = "/zastita-bilja/preporuke",
    CollectionOfPackagingWaste = "/zastita-bilja/sakupljanje-otpada",
}

export enum EducationsRoutes {
    Available = "/tecajevi/dostupno",
    Applied = "/tecajevi/prijavljeno",
    Listened = "/tecajevi/odslusano",
    Reminders = "/tecajevi/podsjetnici",
}

export enum CommunicationRoutes {
    SendNotification = "/komunikacija-s-korisnicima/nova-poruka",
    NotificationTemplates = "/komunikacija-s-korisnicima/predlosci",
    SentNotifications = "/komunikacija-s-korisnicima/poslane-poruke",
}
